import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../../Common/PaginatedTable';
import { Link } from 'react-router-dom';
import { FaEye, FaUserTag } from 'react-icons/fa';
import { OrderCustom } from '../../../Models/OrderCustom';
import { displayDateOnly } from '../../../Utils';
export default function OrderListTable({ data }: { data: OrderCustom[] }) {
  const columnHelper = createColumnHelper<OrderCustom>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center'>
          <Link
            to={`/admin/order/${info.getValue()}/detail`}
            className='buttonMain p-2'
          >
            <FaEye />
          </Link>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 25,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.orderStatus, {
      id: 'orderStatus',
      header: 'Status',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
      size: 25,
    }),
    columnHelper.accessor((row) => row.dateCreated, {
      id: 'dateCreated',
      header: 'Created',
      sortingFn: 'alphanumeric',
      cell: (info) => (
        <i>
          {displayDateOnly(info.getValue() ? new Date(info.getValue()!) : null)}
        </i>
      ),
      footer: (info) => info.column.id,
      filterFn: 'includesString',
      size: 25,
    }),
    columnHelper.accessor((row) => row.dateSubmitted, {
      id: 'dateSubmitted',
      header: 'Submitted',
      sortingFn: 'alphanumeric',
      cell: (info) => (
        <i>
          {displayDateOnly(info.getValue() ? new Date(info.getValue()!) : null)}
        </i>
      ),
      footer: (info) => info.column.id,
      filterFn: 'includesString',
      size: 25,
    }),
    columnHelper.accessor((row) => row.userFirstname, {
      id: 'userFirstname',
      header: 'User',
      sortingFn: 'alphanumeric',
      cell: (info) => (
        <i>
          {info.row.original.userFirstname} {info.row.original.userLastname}
        </i>
      ),
      footer: (info) => info.column.id,
      filterFn: 'includesString',
      size: 50,
    }),
    columnHelper.accessor((row) => row.clientName, {
      id: 'Customer',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
      size: 50,
    }),
    columnHelper.accessor((row) => row.itemCount, {
      id: 'itemCount',
      header: 'Items',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      size: 50,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.totalPrice, {
      id: 'totalPrice',
      header: 'Total',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      // filterFn: 'includesString',
      size: 25,
      enableColumnFilter: false,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
